// extracted by mini-css-extract-plugin
module.exports = {"avatarWrapper":"avatar-view_avatarWrapper__3vKv3","avatar":"avatar-view_avatar__3-BoV"};